import React, { Component } from 'react';
import {
  Button, Col, Row, Switch,
} from 'antd';

class AccountSecurityComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="wrap-account-security-component p-medium">
        <div className="as-header">
          <h1 className="text-left mb-small text-white">Increase your account security</h1>
        </div>
        <Row gutter={window.c.style.COMMON_GUTTER} className="as-body">
          <Col span={10} className="as-body-left">
            <div className="2-fa panel darken-5 p-medium">
              <h2 className="text-left text-white">2FA</h2>
              <Row gutter={12}>
                <Col span={18} className="text-left">
                  <div>
                    Security Key
                    <span>Recommended Yubikey</span>
                  </div>
                  <div>What is a Security Key</div>
                </Col>
                <Col span={6} className="text-right">
                  <Button>Setup</Button>
                </Col>
              </Row>

              <Row gutter={12} className="mt-medium">
                <Col span={18} className="text-left">
                  <div className="bold">
                    Google Authentication
                  </div>
                  <div className="text-small">
                    Used for withdrawals and security modifications
                  </div>
                  <div className="link">
                    Having trouble with your Google Authenticator?
                  </div>
                </Col>
                <Col span={6} className="text-right">
                  <Button>
                    Disable
                  </Button>
                </Col>
              </Row>

              <Row gutter={12} className="mt-medium">
                <Col span={18} className="text-left">
                  <div className="bold">
                    SMS Authentication
                  </div>
                  <div className="text-small">
                    Used for withdrawals and security modifications
                  </div>
                </Col>
                <Col span={6} className="text-right">
                  <Button>
                    On
                  </Button>
                </Col>
              </Row>
            </div>
            <Row className="device-management panel mt-medium darken-5 p-small">
              <Col span={18} className="text-left">
                Device Management
              </Col>
              <Col span={6} className="text-right">
                <Button>
                  Manage
                </Button>
              </Col>
            </Row>
            <Row className="sms-auth panel mt-medium darken-5 p-small">
              <Col span={18} className="text-left">
                Login Password
              </Col>
              <Col span={6} className="text-right">
                <Button>
                  Change
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={12} className="as-body-right">
            <div className="address-management panel darken-5 p-medium">
              <Row>
                <Col span={18} className="text-left">
                  <h2 className="text-white">Address Management</h2>
                  <div className="text-small">
                    Address Management allows you to save and write memos for each of your withdrawal addresses. The
                    optional Whitelist function helps protect your funds by only allowing withdrawals to whitelisted
                    addresses.
                  </div>
                  <div>
                    Whitelist on
                    {' '}
                    <Switch />
                  </div>
                </Col>
                <Col span={6} className="text-right">
                  <Button>Manage</Button>
                </Col>
              </Row>
            </div>
            <div className="account-activity panel mt-medium darken-5 p-medium">
              <Row>
                <Col span={18} className="text-left">
                  <h2 className="text-white">Account activity</h2>
                  <div className="text-small">
                    Last login:2020-05-19 09:07:15
                  </div>
                  <div className="bold">
                    Suspicious account activity?
                    {' '}
                    <span className="link">Disable account</span>
                  </div>
                </Col>
                <Col span={6} className="text-right">
                  <Button>
                    More
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AccountSecurityComponent;
